import React from "react";

// Styles
import { Col, Row } from "react-bootstrap";

// Tabs
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";

// Components
import SearchFilter from "../CustomUIComponents/SearchFilter/SearchFilter";
import GenericDatabaseTable from "./GenericDatabaseTable";
import KeyValueTable from "./KeyValueTable";
import "./DatabaseTables.scss";

// Strings
import { Strings } from "../../resources/i18n/i18n";

// Constants
import { SEARCH_FILTER_FIELDS, SEARCH_FILTER_TYPE } from "../../constants/appConstants";
import { AMORTIZATION_V2_COLUMNS, DAILY_OPERATIONS_V2_COLUMNS, DATABASE_TABLES_NAMES, DATABASE_TABLES_TABS, EMI_RECEIPT_COLUMNS, LOAN_APPLICATION_COLUMNS, LOAN_PROCESS_COLUMNS, RECEIPT_COLUMNS } from "./Constants";
import _ from "lodash";

class DatabaseTables extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loanProcessId: "",
            tabs: DATABASE_TABLES_TABS,
            activeTab: DATABASE_TABLES_TABS[0],
            errorMessage: this.props.errorMessage
        };
    }
    componentDidUpdate(prevProps) {
        if (!_.isEqual(prevProps.errorMessage, this.props.errorMessage)) {
            this.setState({
                errorMessage: this.props.errorMessage
            })
        }
    }

    handleLoanProcessIdChange = (event) => {
        this.setState({
            loanProcessId: event.target.value,
            errorMessage: ""
        });
    };

    handleTabChange = (index) => {
        const selectedTab = this.state.tabs[index];
        this.setState({ activeTab: selectedTab });
    };
    handleOnClickResetFilter = () => {
        this.setState({
            loanProcessId: "",
            errorMessage: ""
        }, () => {
            this.props.resetTableData();
        });
    }
    handleOnClickSearchFilter = () => {
        if (!this.state.loanProcessId) {
            this.setState({
                errorMessage: Strings("enterLoanProcessId")
            })
        } else {
            this.setState({
                errorMessage: ""
            })
            this.props.getLoanApplicationDataTable(this.state.loanProcessId);
            this.props.getLoanProcessTableData(this.state.loanProcessId);
            this.props.getDailyOperationsV2TableData(this.state.loanProcessId);
            this.props.getAmortizationV2TableData(this.state.loanProcessId);
            this.props.getReceiptTableData(this.state.loanProcessId);
            this.props.getEmiRecieptsTableData(this.state.loanProcessId);
        }
    }
    renderSearchFilter = () => {
        let databaseTablesFilters = [
            {
                type: SEARCH_FILTER_TYPE.INPUT,
                searchPlaceHolder: Strings("loanId"),
                handleOnChange: this.handleLoanProcessIdChange,
                Value: this.state.loanProcessId,
                inputType: SEARCH_FILTER_TYPE.NUMBER,
                fieldname: SEARCH_FILTER_FIELDS.MATRICES_ID,
                paddingTop: true,
            },
        ];

        return (
            <SearchFilter
                filters={databaseTablesFilters}
                handleOnClickSearchFilter={this.handleOnClickSearchFilter}
                handleOnClickResetFilter={this.handleOnClickResetFilter}
                paddingRight={0}
                paddingTop={2}
                removeLeftPadding={true}
            />
        );
    };
    renderLoanApplicationTable = () => {
          const dataObj = this.props.loanApplicationData?.[0] || {};
        return (
            <KeyValueTable
                data={dataObj}
                columns={LOAN_APPLICATION_COLUMNS}
                tableTitle={Strings("LoanApplicationData")}
            />
        )
    }
    renderLoanProcessTable = () => {
         const dataObj = this.props.loanProcessTableData?.[0] || {};
        return (
            <KeyValueTable
                data={dataObj}
                columns={LOAN_PROCESS_COLUMNS}
                readOnly={true}
            />
        )
    }

    renderDailyOperationV2Table = () => {
        return (
            <GenericDatabaseTable
                data={this.props.dailyOperationsV2TableData}
                columns={DAILY_OPERATIONS_V2_COLUMNS}
                readOnly={true}
            />
        )
    }

    renderAmortizationV2Table = () => {
        return (
            <GenericDatabaseTable
                data={this.props.amortizationV2TableData}
                columns={AMORTIZATION_V2_COLUMNS}
                readOnly={true}
            />
        )
    }

    renderEmiReceiptsTable = () => {
        return (
            <GenericDatabaseTable
                data={this.props.emiRecieptTableData}
                columns={EMI_RECEIPT_COLUMNS}
                readOnly={true}
            />
        )
    }

    renderReceiptTable = () => {
        return (
            <GenericDatabaseTable
                data={this.props.receiptTableData}
                columns={RECEIPT_COLUMNS}
                readOnly={true}
            />
        )
    }
    renderActiveTabContent = () => {
        switch (this.state.activeTab.value) {

            case DATABASE_TABLES_NAMES.LOAN_APPLICATION:
                return this.renderLoanApplicationTable();

            case DATABASE_TABLES_NAMES.LOAN_PROCESS:
                return this.renderLoanProcessTable();

            case DATABASE_TABLES_NAMES.DAILY_OPERATION_V2:
                return this.renderDailyOperationV2Table();

            case DATABASE_TABLES_NAMES.AMORTIZATION_V2:
                return this.renderAmortizationV2Table();

            case DATABASE_TABLES_NAMES.RECEIPT:
                return this.renderReceiptTable();

            case DATABASE_TABLES_NAMES.EMI_RECEIPTS:
                return this.renderEmiReceiptsTable();

            default:
                return null;
        }
    };
    renderTabPannel = () => {
        return (
            <>
                {this.state.tabs.map(tab => (
                    <TabPanel key={tab.key}>
                        <Row className="paper">
                            <Col md={12} className="ps-0 pe-0 pb-2 pt-2">
                                {this.renderActiveTabContent()}
                            </Col>
                        </Row>
                    </TabPanel>
                ))}

            </>
        )
    }
    render() {
        const selectedIndex = Math.max(
            0,
            this.state.tabs.findIndex(
                tab => tab.value === this.state.activeTab.value
            )
        );

        return (
            <div className="databaseTables">
                <div className="headerText">{Strings("DatabaseTables")}</div>
                <Row className="paper">
                    {this.state.errorMessage &&
                        <Col md={12} className="pt-3">
                            <Row className='errors p-0 m-0'>
                                {Strings(this.state.errorMessage)}
                            </Row>
                        </Col>}
                    <Col md={12} className="pb-2">
                        {this.renderSearchFilter()}
                    </Col>
                    <Col md={12} className="ps-0 pe-0 pb-2 pt-2">
                        <hr className="newhr opacity-100" />
                    </Col>
                    <Tabs selectedIndex={selectedIndex} onSelect={this.handleTabChange}>
                        {/* TAB HEADERS */}
                        <TabList>
                            {this.state.tabs.map(tab => (
                                <Tab
                                    key={tab.key}
                                    className={
                                        tab.value === this.state.activeTab.value
                                            ? "react-tabs__tab react-tabs__tab--selected mt-1"
                                            : "react-tabs__tab mt-1"
                                    }
                                >
                                    {tab.label}
                                </Tab>
                            ))}
                        </TabList>

                        {/* TAB CONTENT */}
                        {this.renderTabPannel()}

                    </Tabs>
                </Row>
            </div>
        );
    }
}

export default DatabaseTables;
